const getResolverDataAttributes = (imagePath, resolverSettings) => {
    var _a, _b;
    return ({
        'data-resolvechain': `${(_b = (_a = decodeURIComponent(imagePath)) === null || _a === void 0 ? void 0 : _a.match(/(set=source|type|ImageVersion|origin).*?(\])/g)) === null || _b === void 0 ? void 0 : _b.toString()}&call=url[file:/product/dynamic.chain]`,
        'data-resolveheight': resolverSettings ? resolverSettings.height.toString() : '',
        'data-resolvewidth': resolverSettings ? resolverSettings.width.toString() : '',
    });
};
export default getResolverDataAttributes;
//# sourceMappingURL=getResolverDataAttributes.js.map